import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCommentsListComponent } from './fi-comments-list.component';
import { FiCommentsListItemComponent } from './fi-comments-list-item/fi-comments-list-item.component';
import { FiCommentsListItemEditComponent } from './fi-comments-list-item-edit/fi-comments-list-item-edit.component';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiCommentAddComponent } from './fi-comment-add/fi-comment-add.component';
import { FiTextEditorSharedModule } from '@fi-shared/fi-text-editor/fi-text-editor-shared.module';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiLikesModule } from '@fi-shared/fi-likes/fi-likes.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiCommentAddScreenComponent } from './fi-comment-add/fi-comment-add-screen.component';
import { FicScreenModule } from '@fi-shared/fic-screen/fic-screen.module';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { FiCommentsListHelperService } from './services/fi-comments-list-helper.service';
import { FiCommentsListStateService } from './services/fi-comments-list-state.service';
import { FiCommentHeaderComponent } from './fi-comments-list-item/fi-comment-header/fi-comment-header.component';
import { FiCommentContentComponent } from './fi-comments-list-item/fi-comment-content/fi-comment-content.component';
import { FiCommentFooterComponent } from './fi-comments-list-item/fi-comment-footer/fi-comment-footer.component';
import { FiCommentSimplifiedViewComponent } from './fi-comments-list-item/fi-comment-simplified-view/fi-comment-simplified-view.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiFormatDateModule,
        FiAttachmentsModule,
        MatIconModule,
        MatCardModule,
        FiTextEditorSharedModule,
        FiContenteditableModule,
        FiBindHtmlCompileModule,
        FiLikesModule,
        MatMenuModule,
        FiProfileIconModule,
        FicScreenModule,
        FiSimpleContenteditableModule,
    ],
    declarations: [
        FiCommentsListComponent,
        FiCommentsListItemComponent,
        FiCommentsListItemEditComponent,
        FiCommentAddComponent,
        FiCommentAddScreenComponent,
        FiCommentHeaderComponent,
        FiCommentContentComponent,
        FiCommentFooterComponent,
        FiCommentSimplifiedViewComponent,
    ],
    exports: [FiCommentsListComponent, FiCommentAddComponent],
    providers: [FiCommentsListHelperService, FiCommentsListStateService],
})
export class FiCommentsListModule {}
